// User roles, as stored on the User node's `role` property and returned by the
// `me` query. Gate UI on these rather than on usernames.
//
//   owner  – the account holder (also what the backend treats as admin)
//   team   – colleagues who use the work/media/journal side of the app
//   (anything else, or none) – a language student
export const OWNER = 'owner'
export const TEAM = 'team'

const norm = (r) => String(r || '').trim().toLowerCase()

export const isOwnerRole = (role) => norm(role) === OWNER
// The team-only chrome (Work dial, Language dial) is for owner + team.
export const isTeamRole = (role) => [OWNER, TEAM].includes(norm(role))
